import { useEffect } from 'react'

/**
 * Run `effect` after `delay` ms of the deps staying unchanged.
 * The pending call is dropped when deps change or the component unmounts.
 */
export function useDebouncedEffect(effect, deps, delay) {
  useEffect(() => {
    const timer = setTimeout(effect, delay)
    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, delay])
}
